// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"65a8c7a9","307":"2714c2be","453":"e98f67e2","531":"b51a9008","545":"dc6c931d","604":"dffe7fe0","656":"6c84c25a","702":"18a10e04","802":"ee08030b","891":"629a1b35","908":"d4313aba","925":"49c6c8ce"}[chunkId] + ".chunk.js";
};